module.exports = __webpack_public_path__ + "img/avatar.5e9e010c.jpeg";